import * as yup from 'yup';

export const createFormikValidator = (schema: yup.ObjectSchema<any>, context?: any) => {
  return (values: any) => {
    try {
      schema.validateSync(values, { 
        abortEarly: false,
        context
      });
      return {};
    } catch (error: any) {
      return error.inner?.reduce((acc: any, err: any) => {
        if (err.path) {
          const pathArray = err.path.split('.');
          pathArray.reduce((current: any, key: string, index: number) => {
            if (index === pathArray.length - 1) {
              current[key] = err.message;
            } else {
              current[key] = current[key] || {};
            }
            return current[key];
          }, acc);
        }
        return acc;
      }, {}) || {};
    }
  };
}; 